import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/JobDetail.css";
import axios from "axios";

const JobDetail = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [aciklama, setAciklama] = useState("");
  const [popupLoading, setPopupLoading] = useState(false);
  const [zatenBasvuruldu, setZatenBasvuruldu] = useState(false);
  const [basvuruBasarili, setBasvuruBasarili] = useState(false);
  const [dogrulukOnayli, setDogrulukOnayli] = useState(false);
  const [uyariMesaji, setUyariMesaji] = useState("");
  const [shakeEffect, setShakeEffect] = useState(false);
  const navigate = useNavigate();
  const [showUyariBox, setShowUyariBox] = useState(false);
  const cvid = 0;

  const token = localStorage.getItem("token");

  const kullanici = {
    kullaniciId: parseInt(localStorage.getItem("userId")),
    kullaniciAdi: localStorage.getItem("userName"),
    kullaniciMail: localStorage.getItem("userEmail")
  };

  const checkBasvuru = async (ilanId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/basvurularim`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const basvurular = res.data.$values || [];

      const basvurduMu = basvurular.some(
        (b) => parseInt(b.ilanId) === parseInt(ilanId) && b.status === true
      );

      setZatenBasvuruldu(basvurduMu);
    } catch (err) {
      console.error("Başvuru kontrol hatası:", err);
    }
  };

  const checkDogrulukBeyan = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/dogrulukbeyan/kontrol`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setDogrulukOnayli(res.data?.status === true);
    } catch (err) {
      console.error("Doğruluk beyanı kontrol hatası:", err);
    }
  };

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/ilan/getirhepsi`);
        const jobList = (res.data.$values || []).filter(j => j.status === true);
        const found = jobList.find(j => j.ilanId.toString() === id);
        setJob(found);
        if (found) checkBasvuru(found.ilanId);
      } catch (err) {
        console.error("İlan çekilirken hata:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
    checkDogrulukBeyan();
  }, [id]);


  const handleSubmit = async () => {
    setPopupLoading(true);

    if (!token) {
      alert("Lütfen giriş yapınız.");
      setPopupLoading(false);
      return;
    }

    const payload = {
      basvuranAciklama: aciklama,
      ilanId: job.ilanId
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/ekle`, payload,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setAciklama("");
      setZatenBasvuruldu(true);
      setBasvuruBasarili(true);

      setTimeout(() => {
        setShowPopup(false);
        setBasvuruBasarili(false);
        navigate("/profil");
      }, 3000);
    } catch (err) {
      console.error("Başvuru hatası:", err.response?.data || err.message);
      alert("Başvuru sırasında hata oluştu.");
    } finally {
      setPopupLoading(false);
    }
  };

  const handleBasvurClick = () => {
    if (!dogrulukOnayli) {
      setUyariMesaji("⚠️ Başvuru yapabilmek için önce özgeçmişinizi tamamlamalısınız.");
      setShowUyariBox(true);
      setShakeEffect(true);
      setTimeout(() => setShakeEffect(false), 500);
      return;
    }
    setShowPopup(true);
    setUyariMesaji("");
  };

  if (loading) return <p>Yükleniyor...</p>;
  if (!job) return <p>İlan bulunamadı.</p>;

  return (
    <div className="job-detail-container">
      <div className="job-detail-box">
        <div className="job-header">
          <h1 className="job-title-header">{job.ilanBaslik}</h1>
          <span className="job-deadline-tag">
            Son Başvuru: {job.gecerlilikTarihi.split("T")[0]}
          </span>
        </div>

        <div className="job-meta-info">
          <p><strong>Pozisyon:</strong> {job.ilanPozisyonAdi}</p>
          <p className="lokasyon">
            {job.ilanIlceAdi} / {job.ilanillerAdi} / {job.ilanUlkelerAdi}
          </p>
        </div>


        <div
          className="job-detail-description"
          dangerouslySetInnerHTML={{ __html: job.ilanAciklamasi }}
        ></div>

        {uyariMesaji && !showPopup && (
          <div className={`uyari-bildirimi ${shakeEffect ? "shake" : ""}`}>
            <span>⚠️ Başvuru yapabilmek için önce özgeçmişinizi tamamlamalısınız.
              <button className="uyari-btn" onClick={() => navigate("/ozgecmisim")}>
                Özgeçmişimi Tamamla
              </button>
            </span>
          </div>
        )}


        {zatenBasvuruldu ? (
          <button className="apply-button" disabled>
            Zaten Başvurdunuz
          </button>
        ) : (
          <button className="apply-button" onClick={handleBasvurClick}>
            Hemen Başvur
          </button>
        )}

      </div>


      {showPopup && (
        <div className="modal-overlay" onClick={() => setShowPopup(false)}>
          <div className="modal-popup" onClick={(e) => e.stopPropagation()}>
            {!basvuruBasarili ? (
              <>
                <h2>İlana Başvur</h2>
                <label>Başvuru ile ilgili eklemek istediğiniz önyazı var mı?</label>
                <textarea
                  placeholder="(İsteğe bağlı)"
                  value={aciklama}
                  onChange={(e) => setAciklama(e.target.value)}
                />
                <div className="btn-row">
                  <button className="cancel-btn" onClick={() => setShowPopup(false)}>İptal</button>
                  <button className="submit-btn" onClick={handleSubmit} disabled={popupLoading}>
                    {popupLoading ? "Gönderiliyor..." : "Başvur"}
                  </button>
                </div>
              </>
            ) : (
              <div className="onayli-bildirim">
                <span className="tik-ikonu">✅</span>
                Başvurunuz başarıyla tamamlandı.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default JobDetail;
